/**
 * POST /api/v1/registration/complete — FW-129, 13-kayit-parola'nin "Hesabı
 * oluştur" çağrısı. Bkz. useRegistrationStart.ts basligi — davetli kayittan
 * (useRegisterComplete.ts, `{user:{id,email}, invitationAccepted}` doner)
 * AYRI bir yanit sekli tasir: `{userId, email, tokens, postRegisterRedirect}`.
 * Spesifikasyon "otomatik oturum (Logined)" der — basarili yanitta `tokens`
 * DOLU beklenir; backend `null` da donebilir (arayuz bunu ACIKCA modeller).
 *
 * KAPSAM SINIRI (brief'e sadik, brief bu ucun TOKEN/SESSION kurulumunu
 * ISTEMEDI — yalniz 3 kayit karesini + ONB-06 yonlendirme HEDEFINI istedi):
 * `tokens` alani burada TASINIR ama bu turda BASKA HICBIR YERE YAZILMAZ
 * (cerez/localStorage YOK — FW-14 kabul kriteri 3 "hassas veri tarayici
 * depolamasina yazilmaz" kuralinin DEVAMI). `postRegisterRedirect` de
 * TASINIR ama YONLENDIRME KARARI `resolvePostLoginTarget.ts` (ONB-06) ile
 * hesaplanir — backend'in bu alani gelecekte baska bir amac icin
 * (audit/log) donebilecegi, TEK yonlendirme kaynagi OLMAYABILECEGI
 * dusunulerek. RegisterPasswordView.vue basarili complete() sonrasi HANGI
 * degeri kullandigini kendi basligında ACIKCA belgeler.
 */
import { useIdentityApiClient, useMutation, type UseMutationReturnType } from '@fusapp-work/shell'

export interface RegistrationCompleteInput {
  readonly registrationToken: string
  readonly password: string
}

export interface RegistrationCompleteTokens {
  readonly accessToken: string
  readonly expiresIn: number
}

export interface RegistrationCompleteResponse {
  readonly userId: string
  readonly email: string
  readonly tokens: RegistrationCompleteTokens | null
  readonly postRegisterRedirect: string | null
}

export function useRegistrationComplete(): UseMutationReturnType<
  RegistrationCompleteResponse,
  Error,
  RegistrationCompleteInput,
  unknown
> {
  const apiClient = useIdentityApiClient()

  return useMutation({
    mutationFn: (body: RegistrationCompleteInput) =>
      apiClient.request<RegistrationCompleteResponse>('/api/v1/registration/complete', {
        method: 'POST',
        body,
      }),
  })
}
